module.exports = __webpack_public_path__ + "static/mask--lower--dotted-0479a8381854dd13f58d2b157b052f56.svg";